<template>
  <AuthContainer>
    <template #form>
      <ZephrPasswordReset/>
    </template>
  </AuthContainer>
</template>
<script>

import {
  AuthContainer,
  ZephrPasswordReset
} from '../components';
import AnonymousPage from '@pages/AnonymousPage.js';

export default {
  name: 'zephr-password-reset-page',
  components: {
    ZephrPasswordReset,
    AuthContainer,
  },
  extends: AnonymousPage,
  props: {
    title: {
      type: String,
      required: false,
      default: function () {
        return this.$t('reset.password');
      }
    }
  },
  methods: {
    getTitle() {
      return `${ this.title } | ${ this.publication.title }`;
    },
    getRedirectLocation() {
      return '/';
    }
  }
};

</script>
